import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const getBranches = (params) => httpClient.get(`${ENDPOINT_API.BRANCHES}`, { params });
const getBranchesLocations = (params) => httpClient.get(`${ENDPOINT_API.BRANCHES}/locations`, { params });

export {
	getBranches,
	getBranchesLocations,
};
